import { Shield, Lock } from 'lucide-react';

const SecurityBadges = () => {
  return (
    <div className="mt-8 text-center">
      <div className="flex items-center justify-center gap-2 text-sm text-muted-foreground mb-4">
        <Shield className="h-4 w-4 text-green-600" />
        <span>256-bit SSL encryption</span>
        <span>•</span>
        <Lock className="h-4 w-4 text-green-600" />
        <span>PCI DSS compliant</span>
      </div>
      
      <p className="text-xs text-muted-foreground max-w-md mx-auto">
        Your payment information is encrypted and processed securely through Revolut. 
        We never store your card details on our servers.
      </p>
    </div>
  );
};

export default SecurityBadges;
